module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"An das Dashboard pinnen"},"en":{"title":"An das Dashboard pinnen"}}')
  delete Component.options._Ctor
}
